import React, { Fragment, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import $ from "jquery";
import { axiosWithoutAuth } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../Context/GlobalContext";
import { PAYMENT_FAILED } from "../../constants";
import { PAGES } from "../../routeConfig";
import { isNumeric, isValidArray, showCardDetails, validateMonthYear } from "../../Layout/Common/common";
import { NewCardPayment } from "../CheckOutNew/Payment/paymentMethod/newcardPayment";
import { redirectToTill, readTillBackPath } from "../../Context/hook/tillRedirect";
import { stashPayAccountSettleData, usePayAccountTillReturn } from "../../Context/hook/usePayAccountTillReturn";
import { useTillReturnBackGuard } from "../../Context/hook/useTillReturnBackGuard";
import { TillSettlingOverlay } from "../../Layout/Common/tillSettlingOverlay";
import { SendMailModal } from "../MyAccount/Payaccount/SendMailModal";
import { PrintInvoiceButton } from "../MyAccount/Payaccount/PrintInvoiceButton";
import { InvalidReferenceId } from "../PayOnline/inValidReferenceId";
import "../MyAccount/Payaccount/PaymentRequired.css";

export const PayInvoiceMain = () => {
  const { urlref } = useParams();
  const { userId } = useAuth();
  const { showDialogAlert, hideNoteAlert, showNoteAlert, showFlashScreen } = useNoteAlert();
  const { sendInvoiceSignal } = useGlobalFunction();
  const { setSelectedPaymentType } = useContext(GlobalContext);
  const { settling, tillReturn, paidInvoices } = usePayAccountTillReturn();

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [paidTransactionId, setPaidTransactionId] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || PAGES.HOME,
  });

  useEffect(() => {
    setSelectedPaymentType("NEWCARD");
  }, []);

  const loadInvoice = async () => {
    setLoading(true);
    try {
      const response = await axiosWithoutAuth.post("PayAccount/GetProformaInvoice", { urlRef: urlref || "" });
      if (response && response.data && response.data.status === 200 && response.data.data) {
        setInvoice(response.data.data);
        setNotFound(false);
        return response.data.data;
      }
      setNotFound(true);
    } catch (error) {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
    return null;
  };

  useEffect(() => {
    if (settling) return;

    loadInvoice().then((data) => {
      if (!tillReturn) return;
      const paidNow = isValidArray(paidInvoices) || (data && data.payStatus === 2);
      if (tillReturn.isSuccess && paidNow) {
        setPaidTransactionId(tillReturn.transId);
        return;
      }
      if (!tillReturn.isSuccess && !(data && data.payStatus === 2)) {
        showDialogAlert({
          content: PAYMENT_FAILED.content,
          title: PAYMENT_FAILED.title,
          primaryBtn: { caption: "Try new card", onClick: tryNewCard },
          scondaryBtn: { caption: "Ok", onClick: hideNoteAlert },
        });
      }
    });
  }, [urlref, settling]);

  const tryNewCard = () => {
    setSelectedPaymentType("NEWCARD");
    $("#newCardPayment").click();
    showCardDetails();
    hideNoteAlert();
  };

  const viewProforma = async () => {
    if (!invoice || !invoice.invoiceNo || pdfLoading) return;
    setPdfLoading(true);
    try {
      await sendInvoiceSignal(invoice.invoiceNo, invoice.invoiceNo, "PAYACCOUNT");
    } finally {
      setPdfLoading(false);
    }
  };

  const processPayment = (token) => {
    const amount = Number(invoice.amountCharged || 0).toFixed(2);
    const params = {
      UserID: userId ? String(userId) : "",
      CompanyID: String(invoice.companyId ?? ""),
      PaymentAmount: amount,
      ExpDate: "",
      Token: token,
      SCNumber: "",
      urlRef: urlref || "",
      cardType: "NEWCARD",
      isSaveCard: false,
      uuid: "",
      InvoiceNo: String(invoice.invoiceNo),
      JsonData: JSON.stringify([{ invoice: String(invoice.paymentRef), amount }]),
      paymentMode: "TI",
      isProforma: true,
    };

    axiosWithoutAuth
      .post("PayAccount/TillPaymentProcess", params)
      .then((response) => {
        const data = typeof response?.data === "string" ? JSON.parse(response.data) : response?.data;
        if (data && data.Status == "Success" && data.RedirectTo && data.ReferenceId) {
          stashPayAccountSettleData({
            transId: data.ReferenceId,
            companyId: String(invoice.companyId ?? "0"),
            userId: userId != null ? String(userId) : "",
            userName: "",
            email: "",
            phone: "",
            totalAmount: amount,
            isProforma: true,
          });
          showFlashScreen({
            messages: ["Taking you to the secure payment page…", "Please do not refresh or close this window."],
          });
          redirectToTill(data.RedirectTo);
          return;
        }
        showFlashScreen(false);
        if (data && data.Message === "Invoice already paid") {
          loadInvoice();
          return;
        }
        showNoteAlert("Payment process failed. Please try again.");
      })
      .catch(() => {
        showFlashScreen(false);
        showNoteAlert("Payment process failed. Please try again.");
      });
  };

  const payNow = () => {
    if (!invoice) return;
    const cardName = document.getElementById("cardName")?.value ?? "";
    const cardExp = document.getElementById("cardExp")?.value ?? "";
    let valid = true;

    if (isNumeric(cardName) == false) {
      $("#newcardNameError").css("display", "block");
      $("#cardName").focus();
      valid = false;
    }
    if (!validateMonthYear(cardExp)) {
      $("#newcardExpError").css("display", "block");
      if (valid) $("#cardExp").focus();
      valid = false;
    }
    if (!valid) {
      showNoteAlert("Please fill in the mandatory fields and try again.");
      return;
    }

    showFlashScreen({
      messages: ["Processing your payment, please wait…", "Please do not refresh or close this window."],
    });
    const [month, year] = cardExp.split("/");
    window.till.tokenize(
      { card_holder: cardName, month: month, year: "20" + year },
      (token) => processPayment(token),
      (errors) => {
        showFlashScreen(false);
        const message = isValidArray(errors) && errors[0].message;
        showNoteAlert(message || "Payment process failed. Please try again.");
      },
    );
  };

  const formatAmount = (value) => Number(value || 0).toFixed(2);

  const renderInvoiceCard = (amountLabel) => (
    <div className="payinvoice-card">
      <div className="payinvoice-card-head">
        <div>
          <span className="payinvoice-card-label">Invoice No</span>
          <span className="payinvoice-card-number">{invoice.invoiceNo}</span>
        </div>
        <button type="button" className="payinvoice-card-view" onClick={viewProforma} disabled={pdfLoading}>
          <img height="20" src="https://cdn.wes.com.au/wes/icons/Pdf.png" alt="" />
          <span>{pdfLoading ? "Opening..." : "View Invoice"}</span>
        </button>
      </div>
      <div className="payinvoice-card-body">
        <div className="payinvoice-card-field">
          <span className="payinvoice-card-label">Invoice Date</span>
          <span className="payinvoice-card-value">{invoice.invoiceDate}</span>
        </div>
        <div className="payinvoice-card-field">
          <span className="payinvoice-card-label">Customer PO#</span>
          <span className="payinvoice-card-value">{invoice.orderRef || "-"}</span>
        </div>
      </div>
      <div className="payinvoice-card-foot">
        <span className="payinvoice-card-label">{amountLabel}</span>
        <span className="payinvoice-card-amount">$ {formatAmount(invoice.amountCharged)}</span>
      </div>
    </div>
  );

  const renderPage = (children) => (
    <div className="container-fluid container-lg payaccount">
      <div className="row">
        <div className="col-lg-12">
          <div className="acc-header py-3">
            <div className="myaccount-address myAccount-header">
              <h1 className="myaccount-title">Proforma Invoice Payment</h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="container-fluid col-lg-9 mt-2 p-3">
            <div className="invoice-filters myaccount-overview">
              <div className="row">
                <div className="col-lg-12">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSkeleton = () =>
    renderPage(
      <Fragment>
        <Skeleton width={260} height={28} style={{ marginBottom: 16 }} />
        <Skeleton count={2} height={40} style={{ marginBottom: 10 }} />
        <Skeleton width={180} height={28} style={{ margin: "24px 0 16px" }} />
        <Skeleton count={3} height={44} style={{ marginBottom: 12 }} />
      </Fragment>,
    );

  const renderStatus = (title, message, actions) =>
    renderPage(
      <Fragment>
        <div className="successmsg" style={{ textAlign: "center", padding: "40px 0" }}>
          <img src="https://cdn.wes.com.au/wes/icons/success.png" alt="Success" />
          <h2 style={{ fontWeight: 600, marginTop: "15px" }}>{title}</h2>
          {message && <p className="lblsubmessage">{message}</p>}
        </div>
        {actions && (
          <div className="reorder-download" style={{ justifyContent: "center", marginBottom: 30 }}>
            {actions}
          </div>
        )}
        <div className="col-lg-10 mx-auto">{renderInvoiceCard("Amount Paid")}</div>
      </Fragment>,
    );

  const renderContent = () => {
    if (settling || loading) return renderSkeleton();

    if (paidTransactionId && invoice) {
      const amount = formatAmount(invoice.amountCharged);
      return renderStatus(
        "Payment Completed",
        "We will process your payment and update your Account",
        <Fragment>
          <SendMailModal
            defaultEmail=""
            transactionId={paidTransactionId}
            companyId={invoice.companyId}
            userId={userId}
            loginName=""
            phoneNumber=""
            totalAmount={amount}
          />
          <PrintInvoiceButton transactionId={paidTransactionId} companyId={invoice.companyId} totalAmount={amount} />
        </Fragment>,
      );
    }

    if (notFound || !invoice) return <InvalidReferenceId orderId={urlref} />;

    if (invoice.payStatus === 2) {
      return renderStatus("Invoice Paid", "This proforma invoice has already been paid.");
    }

    return renderPage(
      <Fragment>
        <div className="myAcc-list">
          <h2>Invoice Awaiting Payment</h2>
        </div>
        <div className="col-lg-10">{renderInvoiceCard("Amount Owing")}</div>
        <div className="selected-shipping-method col-lg-10 payinvoice-payment">
          <div className="myAcc-list">
            <h2>Payment</h2>
          </div>
          <div className="shipping-method-list">
            <div className="shipPayment-listing shipPayment-fix">
              <NewCardPayment handleOnCheck={setSelectedPaymentType} defaultCheck={true} allowSaveCard={false} />
            </div>
          </div>
        </div>
        <div className="total-amount-checkout col-lg-10">
          <p>Total</p>
          <p>$ {formatAmount(invoice.amountCharged)}</p>
        </div>
        <div className="checkout-button pay-now-checkout col-lg-10">
          <span className="return-to-cart d-none d-md-block"></span>
          <div className="button-effect">
            <button className="btn btn-products btn-addcart" onClick={payNow}>
              Pay Now
            </button>
          </div>
        </div>
      </Fragment>,
    );
  };

  return (
    <Fragment>
      <TillSettlingOverlay show={settling} message="Confirming your payment..." />
      {renderContent()}
    </Fragment>
  );
};
